var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_2870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9942 22.0005V21.9996H21.9997V13.9311C21.9997 9.98394 21.1499 6.94336 16.5354 6.94336C14.3171 6.94336 12.8284 8.16069 12.2207 9.31478H12.1565V7.31186H7.78125V21.9996H12.3371V14.7268C12.3371 12.8119 12.7001 10.9602 15.0715 10.9602C17.4081 10.9602 17.4429 13.1455 17.4429 14.8496V22.0005H21.9942Z",
    fill: "#273043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.363281 7.3125H4.92461V22.0002H0.363281V7.3125Z",
    fill: "#273043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64183 0C1.18342 0 0 1.18342 0 2.64183C0 4.10025 1.18342 5.30842 2.64183 5.30842C4.10025 5.30842 5.28367 4.10025 5.28367 2.64183C5.28275 1.18342 4.09933 0 2.64183 0V0Z",
    fill: "#273043"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_2870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/linkedInIcon.92b57fb353e8e6db7f7027c1bc441383.svg";
export { ForwardRef as ReactComponent };